// src/services/cauSessionService.js
import api from "@/api";

const BASE_URL = "/api/driver/cau";

export const CauSessionApi = {
  // GET /api/driver/cau/active?taiXeId=...
  getActiveByDriver(taiXeId) {
    return api
      .get(`${BASE_URL}/active`, { params: { taiXeId } })
      .then((res) => res.data);
  },

  // POST /api/driver/cau/start?taiXeId=...
  // body: { xeId, imgStartUrl, ghiChu }
  startSession(taiXeId, payload) {
    return api
      .post(`${BASE_URL}/start`, payload, {
        params: { taiXeId },
      })
      .then((res) => res.data);
  },

  // POST /api/driver/cau/{id}/end?taiXeId=...
  // body: { imgEndUrl, ghiChu }
  endSession(taiXeId, sessionId, payload) {
    return api
      .post(`${BASE_URL}/${sessionId}/end`, payload, {
        params: { taiXeId },
      })
      .then((res) => res.data);
  },

  // GET /api/driver/cau/history?taiXeId=...
  historyByDriver(taiXeId) {
    return api
      .get(`${BASE_URL}/history`, { params: { taiXeId } })
      .then((res) => res.data);
  },
};
